module.exports = __webpack_public_path__ + "img/1csm_Ersa-Wave-POWERFLOWULTRAXXL-01-900x675_650ac69949.bd234d28.png";